import React from "react";
import "./CardchangePage.css";
import CardChangeImage from "./../../../assets/store-shift-order-img.jpg";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { maintainCartdata } from "../../home/redux/actions";
import { useTranslation } from "react-i18next";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { postRequestcall } from "../../comman/util/postRequest";
import { CART_CLEAR } from "../../constants/apiurl";

function CardchangePage(props) {
  const { t } = useTranslation();
  const cartClear = async (e) => {
    if (props.access_token) {
      e.preventDefault();
      let getclearCartapiResponse = await postRequestcall(
        CART_CLEAR,
        props?.access_token,
        ""
      );
      if (getclearCartapiResponse?.status === 200) {
        props.setCartinformation({
          cart_store_name: "",
          current_store_name: "",
          store_id: "",
        });
        props.setCartclear(false);
        props.cartdata.length = 0;
        await props.maintainCartdata([], {});
        await props.addProducttocart(props.productId);
      }
    } else {
      props.setCartinformation({
        cart_store_name: "",
        current_store_name: "",
        store_id: "",
      });
      props.setCartclear(false);
      props.cartdata.length = 0;
      props.maintainCartdata([], {});
      await props.addProducttocart(props.productId);
    }
  };

  return (
    <Modal className="card-changes-modal" show={props.cartclear} centered>
      <Modal.Body>
        <div className="cardalert_image">
          <LazyLoadImage alt="" src={CardChangeImage}></LazyLoadImage>
        </div>
        <div className="card-alert text-center mt-3">
          <h5 className="font-20">{t("pages.replace")}</h5>
          <p className="font-16 secoundary">
            {props?.language === "En"
              ? t("pages.Your card cantains products from") +
                " " +
                props.cartInformation.cart_store_name +
                " " +
                t(
                  "pages.Do you want to discard the card products and add products from"
                ) +
                " " +
                props.cartInformation.current_store_name
              : `Sepetiniz ${props.cartInformation.cart_store_name} mağazasından ürünler içeriyor Sepetinizdeki ürünlerini kaldırıp ${props.cartInformation.current_store_name} mağazasından ürünler eklemek ister misiniz?`}
          </p>
          <div className="text-center mb-2">
            <button
              className="cancel-btn px-5 me-4"
              onClick={() => props.setCartclear(false)}
            >
              {t("pages.add_delivery.no")}
            </button>
            <button className="btn-submit px-5" onClick={(e) => cartClear(e)}>
              {t("pages.add_delivery.yes")}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

const mapStateToProps = (state) => ({
  language: state?.languageState?.language,
  access_token: state?.login?.access_token,
  cartdata: state?.home?.cartdata,
});

export default connect(mapStateToProps, { maintainCartdata })(CardchangePage);
